import { redirect, type RouteObject } from 'react-router';
import { RouteError } from '@/components/ui/route-error';
import { paths } from '@/config/paths';

/**
 * Route modules export `Component` (the react-router `lazy()` contract).
 */
export const routes: RouteObject[] = [
  {
    // One error screen for every page: a render that throws or a page whose code fails to load.
    errorElement: <RouteError />,
    children: [
      // Without a HydrateFallback react-router warns on every first load.
      { path: paths.home.path, lazy: () => import('./routes/home'), HydrateFallback: () => null },
      { path: paths.in.path, lazy: () => import('./routes/in'), HydrateFallback: () => null },
      {
        path: paths.privacy.path,
        lazy: () => import('./routes/privacy'),
        HydrateFallback: () => null,
      },
      { path: paths.qr.path, lazy: () => import('./routes/qr'), HydrateFallback: () => null },
      {
        path: paths.shipping.path,
        lazy: () => import('./routes/shipping'),
        HydrateFallback: () => null,
      },
      { path: paths.team.path, lazy: () => import('./routes/team'), HydrateFallback: () => null },
      // Anything else (a typo, an old link) lands on the waitlist, never on a bare error screen.
      { path: '*', loader: () => redirect(paths.home.path) },
    ],
  },
];
